import React from 'react';
import { AppOutlinedTextField, appOutlinedTextFieldSx } from '@/components/shared/AppOutlinedTextField';

interface InstructionsSectionProps {
  instructions: string;
  cookingTips: string;
  onInstructionsChange: (value: string) => void;
  onCookingTipsChange: (value: string) => void;
}

export const InstructionsSection: React.FC<InstructionsSectionProps> = ({
  instructions,
  cookingTips,
  onInstructionsChange,
  onCookingTipsChange,
}) => {
  return (
    <div
      className="flex flex-col gap-10"
      style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
    >
      <AppOutlinedTextField
        label="Cooking Instructions(Optional)"
        value={instructions}
        onChange={(e) => onInstructionsChange(e.target.value)}
        placeholder="Enter step by step instructions"
        multiline
        minRows={4}
        fullWidth
        size="small"
        sx={appOutlinedTextFieldSx}
      />

      <AppOutlinedTextField
        label="Cooking Tips(Optional)"
        value={cookingTips}
        onChange={(e) => onCookingTipsChange(e.target.value)}
        placeholder="Enter step by step instructions"
        multiline
        minRows={4}
        fullWidth
        size="small"
        sx={appOutlinedTextFieldSx}
      />
    </div>
  );
};
